var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrendingIncrease(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 5L15.2417 6.90833L11.175 10.975L7.84166 7.64167L1.66666 13.825L2.84166 15L7.84166 10L11.175 13.3333L16.425 8.09167L18.3333 10V5H13.3333Z",
    fill: "#556BF6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendingIncrease);
export default __webpack_public_path__ + "static/media/trending-increase.ea0d6ca7.svg";
export { ForwardRef as ReactComponent };